import { Button, Modal } from "flowbite-react";
import { useState } from "react";

/* ===================== Stage Timeline (Horizontal) – pretty + confirm ===================== */
export default function StageTimeline({
  stages = [],
  currentStageId,
  onClickStage,
}) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingStage, setPendingStage] = useState(null);

  const currentIndexRaw = stages.findIndex((s) => s.id === currentStageId);
  const currentIndex = Math.max(0, currentIndexRaw);
  const total = Math.max(stages.length - 1, 1);
  const progressPct =
    stages.length > 1 && currentIndexRaw >= 0
      ? (currentIndex / total) * 100
      : 0;

  const requestChange = (stage) => {
    if (!stage || stage.id === currentStageId) return;
    setPendingStage(stage);
    setConfirmOpen(true);
  };

  const cancelMove = () => {
    setConfirmOpen(false);
    setPendingStage(null);
  };

  const confirmMove = () => {
    if (pendingStage) onClickStage?.(pendingStage.id);
    setConfirmOpen(false);
    setPendingStage(null);
  };

  const nextIndex = currentIndex + 1;

  return (
    <div className="mb-3 -mx-2 -mt-4 overflow-x-auto bg-gray-50 rounded-lg shadow-sm">
      <div className="min-w-[560px]">
        <div className="relative px-2 pt-4 pb-1">
          {/* trilha */}
          <div className="absolute left-6 right-6 top-8 h-1 rounded-full bg-gray-200" />
          <div
            className="absolute left-6 top-8 h-1 rounded-full bg-gradient-to-r from-green-600 to-green-300 transition-all"
            style={{ width: `${progressPct}%` }}
          />

          <ol className="relative z-10 flex items-center justify-between gap-4">
            {stages.map((s, idx) => {
              const isActive = s.id === currentStageId;
              const isCompleted = currentIndexRaw >= 0 && idx < currentIndex;
              const isNext = idx === nextIndex;

              return (
                <li
                  key={s.id}
                  className="flex flex-col items-center min-w-[96px]"
                >
                  <button
                    type="button"
                    onClick={() => requestChange(s)}
                    title={s.name}
                    className={[
                      "w-8 h-8 rounded-full border flex items-center justify-center text-xs font-semibold transition-all shadow-sm",
                      isActive
                        ? "bg-gray-600 text-white border-gray-600 ring-4 ring-gray-100"
                        : isCompleted
                        ? "bg-green-500 text-white border-green-500 ring-4 ring-green-100"
                        : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50",
                      isNext && !isActive
                        ? "outline outline-2 outline-gray-300"
                        : "",
                    ].join(" ")}
                  >
                    {isCompleted ? (
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M5 13l4 4L19 7"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    ) : (
                      idx + 1
                    )}
                  </button>

                  <span
                    style={{ fontSize: "8px" }}
                    className={[
                      "mt-1 font-medium text-center leading-tight truncate uppercase",
                      isActive
                        ? "text-gray-700"
                        : isCompleted
                        ? "text-green-600"
                        : "text-gray-600",
                    ].join(" ")}
                  >
                    {s.name}
                  </span>
                </li>
              );
            })}
          </ol>
        </div>
      </div>

      {/* Confirmação antes de mover */}
      <Modal show={confirmOpen} size="md" onClose={cancelMove}>
        <Modal.Header>Confirmar mudança de etapa</Modal.Header>
        <Modal.Body>
          {(() => {
            const from = stages[currentIndexRaw]?.name;
            const to = pendingStage?.name;
            const pendingIndex = stages.findIndex(
              (st) => st.id === pendingStage?.id
            );
            const jump =
              pendingIndex >= 0 && currentIndexRaw >= 0
                ? Math.abs(pendingIndex - currentIndexRaw)
                : 0;
            const goingForward = pendingIndex > currentIndexRaw;

            return (
              <div className="space-y-2">
                <p className="text-sm text-gray-700">
                  Mover o card de <b>{from || "—"}</b> para <b>{to || "—"}</b>?
                </p>
                {goingForward && jump > 1 && (
                  <p className="text-xs text-amber-600">
                    Aviso: isso vai pular {jump - 1} etapa(s).
                  </p>
                )}
              </div>
            );
          })()}
        </Modal.Body>
        <Modal.Footer>
          <Button color="gray" onClick={cancelMove}>
            Cancelar
          </Button>
          <Button onClick={confirmMove}>Mover</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
